import { AutoCol } from "..";
import { PageParams } from "../../models";
import { Form } from "react-bootstrap";

interface IPageSizeDropdown {
    updatePageParams: (key: string, value: number) => void;
    pageParams: PageParams;
}

export function PageSizeDropdown({ pageParams, updatePageParams }: IPageSizeDropdown) {
    return (
        <div className="d-flex justify-content-end">
            <AutoCol>
                <Form.Select
                    value={pageParams.pageSize ?? 10}
                    onChange={(e) => updatePageParams("pageSize", +e.target.value)}
                    className="ms-1"
                    size="sm"
                >
                    <option value="10">Show 10</option>
                    <option value="20">Show 20</option>
                    <option value="50">Show 50</option>
                </Form.Select>
            </AutoCol>
        </div>
    );
}
